export default function ShoppingBagSolidIcon({
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M3.187 4.316a.227.227 0 0 0-.227.207l-1.364 15a.23.23 0 0 0 .228.248H12.48l1.405-15.455H3.187ZM5.998 3.346a2.917 2.917 0 0 1 3.62-2.58 3.369 3.369 0 0 0-1.525 2.539l-.05.557h.455l.048-.516a2.93 2.93 0 0 1 1.64-2.378 2.93 2.93 0 0 1 1.65 2.894h.457a3.385 3.385 0 0 0-6.747-.557l-.05.557h.454l.048-.516Z"
      />
      <path
        fill="currentColor"
        d="M11.466.681a2.93 2.93 0 0 1 2.918 3.182h.454a3.382 3.382 0 0 0-4.01-3.577c.2.113.391.245.567.395h.07ZM17.05 4.523a.227.227 0 0 0-.226-.207h-.91V17.61l2.49 1.81L17.05 4.524ZM13.177 19.772l.01.002h4.927l-2.429-1.766-2.508 1.764ZM15.46 4.316h-1.117l-1.367 15.038 2.484-1.747V4.317Z"
      />
    </svg>
  );
}
